module.exports = __webpack_public_path__ + "static/media/attach.728619a6.svg";